import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    defaultError: 'An error occurred while creating your invoice',
    success:
      'Your invoice has been created, you can edit its content before sending it.',
  },
  fr: {
    defaultError:
      'Une erreur est survenue lors de la création de votre facture',
    success:
      'Votre facture a été créée, vous pouvez modifier son contenu avant de l’envoyer.',
  },
} as const);

export default locales;
